import React, {useState} from 'react';
import Layout from '../Shared/Layout';
import {Container, Grid, Paper, Typography} from "@material-ui/core";
import styled from "styled-components";
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import RadioButton from "../Shared/RadioBig";
import {Inertia} from "@inertiajs/inertia";
import {Trans} from "../utils/i18n";
import {IconButton, Modal} from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import {ModalContent} from "../Shared/ProductSelectDynamic";
import {trackConversion} from "../utils/analytics";
import HandymanIcon from '@mui/icons-material/Handyman';

export default function HomeAmazon({ categories }) {
    const { environment, currentCountry } = usePage().props;
    const [modalOpen, setModalOpen] = useState(false);
    
    return (
        <div className={'-mt-12 bg-white'}>
            <div className={`w-full bg-[url('/images/amazon/banner_home_widebg.jpg')] bg-center`}>
                <div
                    className={`lg:mx-auto max-w-[2200px] relative bg-center bg-cover bg-[url('/images/amazon/banner_home_mobile2.jpg')] lg:bg-[url('/images/amazon/banner_home_widefg2.png')] xl:bg-none`}>
                    <Container maxWidth="lg">
                        <div
                            className={`z-10 relative w-full text-white flex flex-col items-center bg-contain bg-bottom bg-no-repeat xl:bg-[url('/images/amazon/banner_home_widefg2.png')]`}>
                            <h1 className={'text-center text-3xl font-bold mt-6 lg:mt-16 m-0'}>
                                <Trans i18nKey="home.amazon.deviceRepair">
                                    Amazon Device Repair
                                </Trans>
                            </h1>
                            <p className={'text-center text-xl font-medium mt-4 mb-0'}>
                                <Trans i18nKey="home.amazon.authorisedRepair">
                                    Amazon Authorised Repair Service
                                </Trans>
                            </p>

                            <div className={'grid grid-cols-12 w-full max-w-2xl gap-6 my-12'}>
                                {
                                    categories
                                        .map((category) =>
                                            <div className={'col-span-6 md:col-span-3 text-black'} key={category.id}>
                                                <RadioButton
                                                    input={{
                                                        checked: false,
                                                        value: category.id,
                                                        onChange: (e) => {
                                                            Inertia.get(route('order', {category: category.id}));
                                                            trackConversion({
                                                                action: 'OrderEntryClickCategory:'+(category.id),
                                                            });
                                                        },
                                                    }}
                                                    field={{
                                                        titel: category.description,
                                                        titleClassName: "!mb-0",
                                                        image: category.image,
                                                        description: category.name === '1004' ? (
                                                            <div className="flex justify-center items-center gap-1">
                                                                {/* <HandymanIcon className="!size-4" /> */}
                                                                <Trans i18nKey="home.amazon.selfRepairOption">Self Repair Option</Trans>
                                                            </div>
                                                         ) : null /*<br/>*/,
                                                        descriptionClassName: "!mt-0",
                                                        style: {
                                                            height: "150px",
                                                        },
                                                        labelStyle: {
                                                            justifyContent: "center",
                                                        }
                                                    }}
                                                    meta={{}}
                                                />
                                            </div>,
                                        )
                                }
                            </div>
                        </div>
                    </Container>
                </div>
            </div>

            <Container maxWidth="lg">
                <div className={'max-w-xl mx-auto'}>
                    <h2 className={'text-center text-3xl font-bold mt-16 mb-0'}>
                        <Trans i18nKey="home.amazon.why">Why Amazon Device Repair?</Trans>
                    </h2>
                    <p className={'text-center text-md font-medium mt-4  mb-0'}>
                        <Trans i18nKey="home.amazon.gotADeviceQuestion">
                            Got an Amazon device that needs to be repaired?
                            Amazon Device Repair is here to help! We provide official Amazon repairs here in the UK, making
                            it quick and easy to get your Amazon device repaired in 3 simple steps.
                        </Trans>
                    </p>
                </div>
                <div className={'relative'}>
                    <div className={'mx-auto mt-16 grid grid-cols-12 gap-6 lg:gap-16 w-full justify-between max-w-4xl'}>
                        <div className={'col-span-12 md:col-span-4 flex justify-center'}>
                            <div className={'flex flex-col items-center rounded-2xl bg-[#F4F9FF] w-full max-w-[264px]'}>
                                <img src={'/images/amazon/home_repair.png'}
                                     className={'rounded-t-2xl border-[#A4D9FB] border-b-4 w-full'}/>
                                <div className={'p-6 text-center flex flex-col items-center flex-1'}>
                                    <p className={'text-xl font-bold  mb-0'}>
                                        <Trans i18nKey="home.amazon.action.request">
                                            Request
                                        </Trans>
                                    </p>
                                    <p className={'my-3 font-regular flex-1'}>
                                        <Trans i18nKey="home.amazon.action.request.description">
                                            Select device & confirm issue
                                        </Trans>
                                    </p>
                                    <div
                                        onClick={() => {
                                            setModalOpen(true);
                                        }}
                                        className={'cursor-pointer no-underline text-sm font-bold bg-[#2A5B97] text-white rounded-md px-6 py-3 hover:bg-[#2A5B97]/70'}
                                    >
                                        <Trans i18nKey="home.amazon.action.request.link">
                                            Request a Repair
                                        </Trans>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'col-span-12 md:col-span-4 flex justify-center'}>
                            <div className={'flex flex-col items-center rounded-2xl bg-[#F4F9FF] w-full max-w-[264px]'}>
                                <img src={'/images/amazon/home_sent.png'}
                                     className={'rounded-t-2xl border-[#A4D9FB] border-b-4 w-full'}/>
                                <div className={'p-6 text-center flex flex-col items-center flex-1'}>
                                    <p className={'text-xl font-bold  mb-0'}>
                                        <Trans i18nKey="home.amazon.action.sent">
                                            Sent
                                        </Trans>
                                    </p>
                                    <div className={'my-3 font-regular flex-1'}>
                                        <Trans i18nKey="home.amazon.action.sent.description">
                                            Send device for fast repair
                                        </Trans>
                                    </div>
                                    <InertiaLink
                                        className={'no-underline text-sm font-bold bg-[#2A5B97] text-white rounded-md px-6 py-3 hover:bg-[#2A5B97]/70'}
                                        href={route('track.index')}>
                                        <Trans i18nKey="home.amazon.action.sent.link">
                                            Repair Status
                                        </Trans>
                                    </InertiaLink>
                                </div>
                            </div>
                        </div>
                        <div className={'col-span-12 md:col-span-4 flex justify-center'}>
                            <div className={'flex flex-col items-center rounded-2xl bg-[#F4F9FF] w-full max-w-[264px]'}>
                                <img src={'/images/amazon/home_return.png'}
                                     className={'rounded-t-2xl border-[#A4D9FB] border-b-4 w-full'}/>
                                <div className={'p-6 text-center flex flex-col items-center flex-1'}>
                                    <p className={'text-xl font-bold  mb-0'}>
                                        <Trans i18nKey="home.amazon.action.return">
                                            Return
                                        </Trans>
                                    </p>
                                    <p className={'my-3 font-regular flex-1'}>
                                        <Trans i18nKey="home.amazon.action.return.description">
                                            Repaired device returned directly to you
                                        </Trans>
                                    </p>
                                    <InertiaLink
                                        className={'no-underline text-sm font-bold bg-[#2A5B97] text-white rounded-md px-6 py-3 hover:bg-[#2A5B97]/70'}
                                        href={route('track.index')}>
                                        <Trans i18nKey="home.amazon.action.return.link">
                                            Track my device
                                        </Trans>
                                    </InertiaLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            {currentCountry !== 'US' && (
                <Container maxWidth="lg">
                    <div className={'max-w-xl mx-auto'}>
                        <h2 className={'text-center text-3xl font-bold mt-16 mb-0'}>
                            <Trans i18nKey="home.amazon.selfRepairServices">Self Repair Services</Trans>
                        </h2>
                    </div>
          
                    <div className={'relative'}>
                        <div className={'mx-auto mt-16 grid grid-cols-12 gap-6 lg:gap-16 w-full justify-between max-w-4xl'}>
                            <div className={'col-span-12 md:col-span-6 flex justify-center'}>
                                <div className={'flex flex-col items-center rounded-2xl bg-[#F4F9FF] w-full max-w-[264px]'}>
                                    <img src={'/images/amazon/home_spare-parts.png'}
                                        className={'rounded-t-2xl border-[#A4D9FB] border-b-4 w-full'}/>
                                    <div className={'p-6 text-center flex flex-col items-center flex-1'}>
                                        <p className={'text-xl font-bold  mb-0'}>
                                            <Trans i18nKey={"home.amazon.selfRepair.buySpareParts"}>
                                                Buy Spare Parts
                                            </Trans>
                                        </p>
                                        <p className={'my-3 font-regular flex-1'}>
                                            <Trans i18nKey={"home.amazon.selfRepair.buySpareParts.description"}>
                                                Buy Genuine Parts
                                            </Trans>
                                        </p>
                                        <InertiaLink
                                            className={'no-underline text-sm font-bold bg-[#2A5B97] text-white rounded-md px-6 py-3 hover:bg-[#2A5B97]/70'}
                                            href={route('partsshop.index')}
                                        >
                                            <Trans i18nKey={"home.amazon.selfRepair.buySpareParts.cta"}>
                                                Buy Spare Parts
                                            </Trans>
                                        </InertiaLink>
                                    </div>
                                </div>
                            </div>
                            <div className={'col-span-12 md:col-span-6 flex justify-center'}>
                                <div className={'flex flex-col items-center rounded-2xl bg-[#F4F9FF] w-full max-w-[264px]'}>
                                    <img src={'/images/amazon/home_download.png'}
                                        className={'rounded-t-2xl border-[#A4D9FB] border-b-4 w-full'}/>
                                    <div className={'p-6 text-center flex flex-col items-center flex-1'}>
                                        <p className={'text-xl font-bold  mb-0'}>
                                            <Trans i18nKey={"home.amazon.selfRepair.downloadDocumentation"}>
                                                Download Documentation
                                            </Trans>
                                        </p>
                                        <div className={'my-3 font-regular flex-1'}>
                                        <Trans i18nKey={"home.amazon.selfRepair.downloadDocumentation.description"}>
                                            Self Repair Documentation
                                        </Trans>
                                        </div>
                                        <InertiaLink
                                            className={'no-underline text-sm font-bold bg-[#2A5B97] text-white rounded-md px-6 py-3 hover:bg-[#2A5B97]/70'}
                                            href={route('selfrepair.documentation.index')}
                                        >
                                            <Trans i18nKey="home.amazon.selfRepair.downloadDocumentation.cta">
                                                Download Documentation
                                            </Trans>
                                        </InertiaLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            )}

                <div className={'max-w-4xl mx-auto mt-32 mb-16'}>
                    <h2 className={'text-center text-2xl font-bold mb-0'}>
                        <Trans i18nKey="home.amazon.anyDoubt">
                            Have any doubt?
                        </Trans>
                    </h2>
                    <p className={'text-center text-md font-medium mt-4  mb-0'}>
                        <Trans i18nKey="home.amazon.officiallyReferred">
                            Our service is officially referred by Amazon Customer Service.
                        </Trans>
                        <br/><br/>

                        <Trans i18nKey="home.amazon.openChat">
                            If you need any support with your repair request, you can open a Chat with one of our Customer
                            Support Agents by clicking the Chat button below.
                        </Trans><br/><br/>

                        <Trans i18nKey="home.amazon.verifyOption">
                            If you prefer, you can still verify the best option for your faulty device with Amazon Customer
                            Service on their own site <a className={'font-bold'} href={'https://www.amazon.co.uk/gp/help/customer/display.html'} target={'_blank'}>here</a>.
                        </Trans><br/><br/>

                        <Trans i18nKey="home.amazon.verifyOption.disclaimer">
                            By clicking on this link you will be redirected to an external website
                        </Trans>

                    </p>
                </div>
            </Container>

            <div className={'bg-[#F4F9FF] py-24 -mb-16'}>
                <Container>
                    <div className={'grid grid-cols-12 '}>
                        <div className={'col-span-12 sm:col-span-6 md:col-span-3 flex flex-col items-center'}>
                            <img src={'/images/amazon/expressRepair.svg'} alt={'Express Repairs'} className={'w-full max-w-[72px]'}/>
                            <p className={'font-medium'}>
                                <Trans i18nKey="home.amazon.expressRepair">
                                    Express Repairs
                                </Trans>
                            </p>
                        </div>
                        <div className={'col-span-12 sm:col-span-6 md:col-span-3 flex flex-col items-center'}>
                            <img src={'/images/amazon/genuineParts.svg'} className={'w-full max-w-[72px]'}
                                 alt={'Genuine Amazon Parts'}/>
                            <p className={'font-medium'}>
                                <Trans i18nKey="home.amazon.genuineParts">
                                    Genuine Amazon Parts
                                </Trans>
                            </p>
                        </div>
                        <div className={'col-span-12 sm:col-span-6 md:col-span-3 flex flex-col items-center'}>
                            <img src={'/images/amazon/technicians.svg'} className={'w-full max-w-[72px]'}
                                 alt={'Qualified Technicians'}/>
                            <p className={'font-medium'}>
                                <Trans i18nKey="home.amazon.technicians">
                                    Qualified Technicians
                                </Trans>
                            </p>
                        </div>
                        <div className={'col-span-12 sm:col-span-6 md:col-span-3 flex flex-col items-center'}>
                            <img src={'/images/amazon/servicePartner.svg'} className={'w-full max-w-[72px]'}
                                 alt={'Official Amazon Service Partner'}/>
                            <p className={'font-medium'}>
                                <Trans i18nKey="home.amazon.servicePartner">
                                    Official Amazon Service Partner
                                </Trans>
                            </p>
                        </div>
                    </div>
                </Container>
            </div>
            {
                modalOpen &&
                <Modal
                    open={true}
                    onClose={() => {
                        setModalOpen(false);
                    }}
                >
                    <ModalContent>
                        <IconButton aria-label="delete" onClick={() => {
                            setModalOpen(false);
                        }}
                        style={{
                            position: 'absolute',
                            top: '1.5rem',
                            right: '1.5rem',
                        }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <div>
                            <h1 className={'text-center text-3xl font-bold mt-6 lg:mt-16 m-0'}>
                                <Trans i18nKey="home.amazon.modalTitle">
                                    Which kind of device do you need to repair?
                                </Trans>
                            </h1>
                            <div className={'justify-center grid grid-cols-12 w-full gap-6 my-12'}>
                                {
                                    categories
                                        .map((category) =>
                                            <div className={'justify-center col-span-6 md:col-span-3 text-black'} key={category.id}>
                                                <RadioButton
                                                    input={{
                                                        checked: false,
                                                        value: category.id,
                                                        onChange: (e) => {
                                                            Inertia.get(route('order', {category: category.id}));
                                                            trackConversion({
                                                                action: 'OrderEntryClickCategory:'+(category.id),
                                                            });
                                                        },
                                                    }}
                                                    field={{
                                                        titel: category.description,
                                                        titleClassName: "!mb-0",
                                                        image: category.image,
                                                        description: category.name === '1004' ? (
                                                            <div className="flex justify-center items-center gap-1">
                                                                {/* <HandymanIcon className="!size-4" /> */}
                                                                <Trans i18nKey="home.amazon.selfRepairOption">Self Repair Option</Trans>
                                                            </div>
                                                         ) : null /*<br/>*/,
                                                        descriptionClassName: "!mt-0",
                                                        style: {
                                                            height: "150px",
                                                        },
                                                        labelStyle: {
                                                            justifyContent: "center",
                                                        }
                                                    }}
                                                    meta={{}}
                                                />
                                            </div>,
                                        )
                                }
                            </div>
                        </div>
                    </ModalContent>
                </Modal>
            }
        </div>
    )
}

HomeAmazon.layout = page => <Layout children={page}/>;
